<template lang="pug">
  title-tab(:msg="$t('title.news')")
    v-row(no-gutters)
      v-col(cols=12 v-for='(item,index) in items', :key='index').pt-3
        .newsbackground.mt-3
          .pa-5
            h3.white--text {{ item.title }}
            h5.white--text {{ item.updated_at | dateFormat }}
          v-divider(color='#ffffff')
          .body-newsbackground.pa-5(v-html='item.description')
    v-row(no-gutters  v-if='items.length===0')
      v-col(cols=12).pt-3
        n-empty

</template>
<script> 
import { news as apiNews } from '@/apis'  

export default { 
  data: () => ({  
    items : [], 
  }),  

  async created () { 
    await this.load() 
  },

  methods : {
    async load () {
      let type = { type : 2 } 
      const [err,data ] = await apiNews.getNews(type) 
      
      if(err) {
        this.$alert('',err,'warning') 
        return
      }     
      this.items = data 
    }
  } 
}
</script>
<style scoped>    
.newsbackground{
  background-color:var(--bg-main-color);   
} 
.body-newsbackground {
  background-color: white;
}
.newsbackground >>> img{
  width: 100%;
}
</style>